import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSms(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15 13H20V10H15V13ZM15 15L13.85 16.15C13.6833 16.3167 13.5 16.3583 13.3 16.275C13.1 16.1917 13 16.0333 13 15.8V9C13 8.71667 13.0958 8.47917 13.2875 8.2875C13.4792 8.09583 13.7167 8 14 8H21C21.2833 8 21.5208 8.09583 21.7125 8.2875C21.9042 8.47917 22 8.71667 22 9V14C22 14.2833 21.9042 14.5208 21.7125 14.7125C21.5208 14.9042 21.2833 15 21 15H15ZM6 23C5.45 23 4.97917 22.8042 4.5875 22.4125C4.19583 22.0208 4 21.55 4 21V3C4 2.45 4.19583 1.97917 4.5875 1.5875C4.97917 1.19583 5.45 1 6 1H16C16.55 1 17.0208 1.19583 17.4125 1.5875C17.8042 1.97917 18 2.45 18 3V7H16V6H6V18H16V16H18V21C18 21.55 17.8042 22.0208 17.4125 22.4125C17.0208 22.8042 16.55 23 16 23H6ZM6 20V21H16V20H6ZM6 4H16V3H6V4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
